<template>
  <div
    data-cy="post-content"
    class="anz-post__content anz-text-break-word anz-mt-xs"
    :class="{
      'anz-post__content--author':
        showContentAuthor || (showParentAuthorRef && postRoot.parentPost),
    }"
  >
    <!-- @authorName -->
    <template v-if="showParentAuthorRef && postRoot.parentPost">
      <a-button
        className="anz-link anz-text-break-all anz-color-gray-700 anz-link-hover-underline"
        add-href
        :href="postRoot.parentPost.author.profileLink"
      >
        <template #title>
          @{{ postRoot.parentPost.author.nickname }}:
        </template>
      </a-button>
    </template>
    <!-- parent annotation -->
    <post-single-parent
      v-if="showParentAnnotation && postRoot.parentPost"
      :post-root="postRoot"
    />
    <!-- ???? -->
    <span v-if="showContentAuthor" class="anz-mr-xs">
      <span class="anz-color-gray-700" v-if="showContentAuthor === 'report'">{{
        $translate('post.texts.contentAuthorReportedText')
      }}</span>
      <!-- Author name -->
      <span
        class="anz-text-break-all anz-color-gray-700"
        v-if="configuration.widget.postUserLinkDisabled"
      >
        {{ postRoot.post.author.nickname }}
      </span>
      <a-button
        v-else
        add-href
        :href="generateProfileRoute(postRoot.post.author)"
        :title="postRoot.post.author.nickname"
        className="anz-link anz-text-break-all anz-color-gray-700 anz-link-hover-underline"
        :class="{
          'anz-color-primary': postRoot.post.postMeta.isNew && allowShowNew,
        }"
      />
      <span class="anz-color-gray-700" v-if="showContentAuthor === 'reply'">{{
        $translate('post.texts.contentAuthorReplies')
      }}</span>
      <span class="anz-color-gray-700">:</span>
    </span>
    <!-- post violation -->
    <div class="anz-post__content-alert" v-if="postRoot.post.isHidden()">
      <post-single-violation :post="postRoot.post" />
    </div>
    <!-- blocked user content -->
    <div
      class="anz-post__content-alert"
      v-else-if="postRoot.post.postMeta.blockedByUser"
    >
      <a-error title="Príspevok je skrytý. Diskutér je na vašom blackliste." />
    </div>
    <!-- post content -->
    <template v-else-if="postRoot.post.content.length > 0">
      <template v-if="!postEditing">
        <!-- post content -->
        <template v-if="!postEditing && !stripLongText">
          <div
            class="anz-post__content-text"
            :class="{ 'anz-inline': canEdit }"
            v-html="postRoot.post.content"
          ></div>
          <post-edit-button
            :post-root="postRoot"
            @toggle-edit-form="$emit('toggle-edit-form')"
            class-name="anz-link anz-color-primary anz-link-underline anz-ml-xs"
          />
        </template>
        <!-- post stripped content -->
        <template v-else>
          <span
            ref="postContent"
            class="anz-post__content-text anz-text-truncate-content"
            v-html="
              truncate(
                postRoot.post.content,
                stripLongTextLength,
                stripLongTextSuffix
              )
            "
          ></span>
          <a-button
            v-if="
              postRoot.post.content.length >= stripLongTextLength &&
                stripLongTextButton
            "
            class-name="anz-text-truncate-toggle anz-link anz-color-primary anz-link-hover-underline"
            :title="$translate('post.actions.showFullPost')"
            @click="expandTruncate(postRoot.post.content, $refs.postContent)"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import PostSingleViolation from '@/components/Post/PostSingleViolation.vue'
import AError from '@/components/Post/SinglePost/AError.vue'
import { PostsRoot } from '@/composables/post/postList'
import PostSingleParent from '@/components/Profile/PostSingleParent.vue'
import { useRouter } from '@/routing/router'
import PostEditButton from '@/components/Post/SinglePost/PostEditButton.vue'
import useConfiguration from '@/composables/configuration/configuration'

export default defineComponent({
  name: 'PostContent',
  emits: ['toggle-edit-form'],
  components: {
    PostEditButton,
    PostSingleParent,
    AError,
    PostSingleViolation,
    AButton,
  },
  props: {
    stripLongText: {
      type: Boolean,
      default: false,
    },
    showContentAuthor: {
      type: String,
      default: '',
    },
    stripLongTextSuffix: {
      type: String,
      default: ' ',
    },
    stripLongTextButton: {
      type: Boolean,
      default: true,
    },
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    stripLongTextLength: {
      type: Number,
      default: 235,
    },
    showParentAuthorRef: {
      type: Boolean,
      default: false,
    },
    showParentAnnotation: {
      type: Boolean,
      default: false,
    },
    allowShowNew: {
      type: Boolean,
      default: false,
    },
    postEditing: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    expandTruncate(text: any, target: any) {
      if (target === undefined) {
        return false
      }

      target.innerHTML = text
      target.classList.add('is-expanded')
    },
    truncate(text: any, length: number, suffix: any) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    },
  },
  setup() {
    return {
      ...useRouter(),
      ...useConfiguration(),
    }
  },
})
</script>
